import { Drawer, DrawerProps } from '@mui/material';

interface IProps {
  children?: React.ReactNode;
}

const DrawerWrapper: React.FC<IProps & DrawerProps> = ({ children, ...props }) => {
  const isModalDrawer = props.variant === undefined || props.variant === 'temporary';

  return (
    <Drawer
      {...props}
      ModalProps={
        isModalDrawer
          ? {
              ...props.ModalProps,
              componentsProps: {
                ...props.ModalProps?.componentsProps,
                root: {
                  ...props.ModalProps?.componentsProps?.root,
                  role: props.ModalProps?.componentsProps?.root?.role ?? 'dialog',
                  'aria-modal': props.ModalProps?.componentsProps?.root?.['aria-modal'] ?? 'true',
                },
              },
            }
          : props.ModalProps
      }
    >
      {children}
    </Drawer>
  );
};

export default DrawerWrapper;
